// import { React, useState, useEffect } from "react";
// import axios from "axios";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import Container from "react-bootstrap/Container";
// import Table from "react-bootstrap/Table";
// import Card from "react-bootstrap/Card";
// import { Trophy } from "react-bootstrap-icons";
// import { AuthConsumer } from "../helpers/AuthContext";
// import Sidebar from "../components/Sidebar";
// import "../styles/responsive.css";

// const FULLY_LABELED_THRESHOLD = 4;

// const ResultsPage = () => {
//   //user list
//   const [userList, setUserList] = useState(null);

//   //Leaderboard list
//   const [lboard, setLboard] = useState(null);

//   //personal stats
//   const [pstats, setPstats] = useState(null);

//   //overall stats
//   const [ostats, setOstats] = useState(null);
//   const [total, setTotal] = useState(0);
//   const [fullyLabeled, setFullyLabeled] = useState(0);

//   const getUserData = () => {
//     if (userList && pstats && lboard) {
//       return;
//     }

//     axios.get("/api/users/userlist").then((res) => {
//       //setting user list
//       setUserList(res.data);
//     });
//   };

//   const getCompData = () => {
//     if (total) {
//       return;
//     }

//     axios.get("/api/components/complist").then((res) => {
//       //Setting overall stats
//       setOstats(res.data);
//     });
//   };

//   //Await until after user list is set
//   useEffect(() => {
//     if (!userList) {
//       return;
//     }

//     const email = localStorage.getItem("Email");

//     if (email && email !== "guest") {
//       setPstats(userList.find((user) => email === user.email));
//     }

//     //Sort users and get top results
//     userList.sort((a, b) =>
//       a.components.length < b.components.length ? 1 : -1
//     );

//     const nor = 10;
//     setLboard(userList.slice(0, nor));
//   }, [userList]);

//   //Await until after overall stats have been set
//   useEffect(() => {
//     if (!ostats) {
//       return;
//     }

//     let sum = 0;
//     let fullyLabeledCount = 0;
//     for (let i = 0; i < ostats.length; i++) {
//       sum += ostats[i].labels.length;
//       if (ostats[i].labels.length >= FULLY_LABELED_THRESHOLD) {
//         fullyLabeledCount += 1;
//       }
//     }

//     setFullyLabeled(fullyLabeledCount);
//     setTotal(sum);
//   }, [ostats]);

//   //Page reload use effect
//   useEffect(() => {
//     //Get leaderboard data
//     getUserData();
//     getCompData();
//   }, []);

//   return (
//     <AuthConsumer>
//       {({ Auth }) => {
//         //If admin
//         if (Auth === "Admin") {
//           return (
//             <div>
//               <Sidebar />
//               <div className="content-with-sidebar">
//                 <Container className="mobile-padding-sm">
//                   <Row style={{ padding: "20px 0" }}>
//                     <Col xs={12} lg={6} className="mb-3 mb-lg-0">
//                       <Card>
//                         <Card.Header as="h5">Overall IC Stats</Card.Header>
//                         <Container
//                           className="mobile-padding-sm"
//                           style={{ paddingTop: "20px" }}
//                         >
//                           <div className="table-responsive-mobile">
//                             <Table bordered hover size="sm">
//                               <thead>
//                                 <tr>
//                                   <th colSpan="2">Component Stats</th>
//                                 </tr>
//                               </thead>
//                               {ostats && (
//                                 <tbody>
//                                   <tr>
//                                     <td>Unique Components Labeled</td>
//                                     <td>{ostats.length}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>Total Components Labeled</td>
//                                     <td>{total}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>{`Fully Labeled Components (${FULLY_LABELED_THRESHOLD} Or More Labels)`}</td>
//                                     <td>{fullyLabeled}</td>
//                                   </tr>
//                                 </tbody>
//                               )}
//                             </Table>
//                           </div>
//                         </Container>
//                       </Card>
//                     </Col>
//                     <Col xs={12} lg={6}>
//                       <Card>
//                         <Card.Header as="h5">Personal Stats</Card.Header>
//                         {pstats ? (
//                           <Container
//                             className="mobile-padding-sm"
//                             style={{ paddingTop: "20px" }}
//                           >
//                             <div className="table-responsive-mobile">
//                               <Table bordered hover size="sm">
//                                 <thead>
//                                   <tr>
//                                     <th colSpan="2">{pstats.fname}</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   <tr>
//                                     <td>Domain</td>
//                                     <td>{pstats.domain}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>Components Labeled</td>
//                                     <td>{pstats.components.length}</td>
//                                   </tr>
//                                 </tbody>
//                               </Table>
//                             </div>
//                           </Container>
//                         ) : (
//                           <Container
//                             className="mobile-padding-sm"
//                             style={{
//                               paddingTop: "20px",
//                               paddingBottom: "20px",
//                             }}
//                           >
//                             Please <a href="/signup">signup</a> or{" "}
//                             <a href="/login">login</a> to view your personal
//                             stats.
//                           </Container>
//                         )}
//                       </Card>
//                     </Col>
//                   </Row>
//                   <Row style={{ padding: "20px 0" }}>
//                     <Card>
//                       <Card.Header as="h4">Labeling Leaderboard</Card.Header>
//                       <Container
//                         className="mobile-padding-sm"
//                         style={{ paddingTop: "20px" }}
//                       >
//                         <div className="table-responsive-mobile">
//                           <Table bordered hover size="sm">
//                             <thead>
//                               <tr>
//                                 <th>Ranking</th>
//                                 <th>Name</th>
//                                 <th>No. Components Labeled</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {lboard &&
//                                 lboard.map((user, index) => {
//                                   return (
//                                     <tr key={user.fname}>
//                                       <td>{index + 1}</td>
//                                       {index < 3 ? (
//                                         <td>
//                                           {user.fname} <Trophy />
//                                         </td>
//                                       ) : (
//                                         <td>{user.fname}</td>
//                                       )}
//                                       <td>{user.components.length}</td>
//                                     </tr>
//                                   );
//                                 })}
//                             </tbody>
//                           </Table>
//                         </div>
//                       </Container>
//                     </Card>
//                   </Row>
//                 </Container>
//               </div>
//             </div>
//           );
//         }

//         //If logged in user
//         else if (Auth === "User") {
//           return (
//             <div>
//               <Sidebar />
//               <div className="content-with-sidebar">
//                 <Container className="mobile-padding-sm">
//                   <Row style={{ padding: "20px 0" }}>
//                     <Col xs={12} lg={6} className="mb-3 mb-lg-0">
//                       <Card>
//                         <Card.Header as="h5">Overall IC Stats</Card.Header>
//                         <Container
//                           className="mobile-padding-sm"
//                           style={{ paddingTop: "20px" }}
//                         >
//                           <div className="table-responsive-mobile">
//                             <Table bordered hover size="sm">
//                               <thead>
//                                 <tr>
//                                   <th colSpan="2">Component Stats</th>
//                                 </tr>
//                               </thead>
//                               {ostats && (
//                                 <tbody>
//                                   <tr>
//                                     <td>Unique Components Labeled</td>
//                                     <td>{ostats.length}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>Total Components Labeled</td>
//                                     <td>{total}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>{`Fully Labeled Components (${FULLY_LABELED_THRESHOLD} Or More Labels)`}</td>
//                                     <td>{fullyLabeled}</td>
//                                   </tr>
//                                 </tbody>
//                               )}
//                             </Table>
//                           </div>
//                         </Container>
//                       </Card>
//                     </Col>
//                     <Col xs={12} lg={6}>
//                       <Card>
//                         <Card.Header as="h5">Personal Stats</Card.Header>
//                         {pstats ? (
//                           <Container
//                             className="mobile-padding-sm"
//                             style={{ paddingTop: "20px" }}
//                           >
//                             <div className="table-responsive-mobile">
//                               <Table bordered hover size="sm">
//                                 <thead>
//                                   <tr>
//                                     <th colSpan="2">{pstats.fname}</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   <tr>
//                                     <td>Domain</td>
//                                     <td>{pstats.domain}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>Components Labeled</td>
//                                     <td>{pstats.components.length}</td>
//                                   </tr>
//                                 </tbody>
//                               </Table>
//                             </div>
//                           </Container>
//                         ) : (
//                           <Container
//                             className="mobile-padding-sm"
//                             style={{
//                               paddingTop: "20px",
//                               paddingBottom: "20px",
//                             }}
//                           >
//                             Please <a href="/signup">signup</a> or{" "}
//                             <a href="/login">login</a> to view your personal
//                             stats.
//                           </Container>
//                         )}
//                       </Card>
//                     </Col>
//                   </Row>
//                   <Row style={{ padding: "20px 0" }}>
//                     <Card>
//                       <Card.Header as="h4">Labeling Leaderboard</Card.Header>
//                       <Container
//                         className="mobile-padding-sm"
//                         style={{ paddingTop: "20px" }}
//                       >
//                         <div className="table-responsive-mobile">
//                           <Table bordered hover size="sm">
//                             <thead>
//                               <tr>
//                                 <th>Ranking</th>
//                                 <th>Name</th>
//                                 <th>No. Components Labeled</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {lboard &&
//                                 lboard.map((user, index) => {
//                                   return (
//                                     <tr key={user.fname}>
//                                       <td>{index + 1}</td>
//                                       {index < 3 ? (
//                                         <td>
//                                           {user.fname} <Trophy />
//                                         </td>
//                                       ) : (
//                                         <td>{user.fname}</td>
//                                       )}
//                                       <td>{user.components.length}</td>
//                                     </tr>
//                                   );
//                                 })}
//                             </tbody>
//                           </Table>
//                         </div>
//                       </Container>
//                     </Card>
//                   </Row>
//                 </Container>
//               </div>
//             </div>
//           );
//         }

//         //If guest
//         else {
//           return (
//             <div>
//               <Sidebar />
//               <div className="content-with-sidebar">
//                 <Container className="mobile-padding-sm">
//                   <Row style={{ padding: "20px 0" }}>
//                     <Col xs={12} lg={6} className="mb-3 mb-lg-0">
//                       <Card>
//                         <Card.Header as="h5">Overall IC Stats</Card.Header>
//                         <Container
//                           className="mobile-padding-sm"
//                           style={{ paddingTop: "20px" }}
//                         >
//                           <div className="table-responsive-mobile">
//                             <Table bordered hover size="sm">
//                               <thead>
//                                 <tr>
//                                   <th colSpan="2">Component Stats</th>
//                                 </tr>
//                               </thead>
//                               {ostats && (
//                                 <tbody>
//                                   <tr>
//                                     <td>Unique Components Labeled</td>
//                                     <td>{ostats.length}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>Total Components Labeled</td>
//                                     <td>{total}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>{`Fully Labeled Components (${FULLY_LABELED_THRESHOLD} Or More Labels)`}</td>
//                                     <td>{fullyLabeled}</td>
//                                   </tr>
//                                 </tbody>
//                               )}
//                             </Table>
//                           </div>
//                         </Container>
//                       </Card>
//                     </Col>
//                     <Col xs={12} lg={6}>
//                       <Card>
//                         <Card.Header as="h5">Personal Stats</Card.Header>
//                         {pstats ? (
//                           <Container
//                             className="mobile-padding-sm"
//                             style={{ paddingTop: "20px" }}
//                           >
//                             <div className="table-responsive-mobile">
//                               <Table bordered hover size="sm">
//                                 <thead>
//                                   <tr>
//                                     <th colSpan="2">{pstats.fname}</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   <tr>
//                                     <td>Domain</td>
//                                     <td>{pstats.domain}</td>
//                                   </tr>
//                                   <tr>
//                                     <td>Components Labeled</td>
//                                     <td>{pstats.components.length}</td>
//                                   </tr>
//                                 </tbody>
//                               </Table>
//                             </div>
//                           </Container>
//                         ) : (
//                           <Container
//                             className="mobile-padding-sm"
//                             style={{
//                               paddingTop: "20px",
//                               paddingBottom: "20px",
//                             }}
//                           >
//                             Please <a href="/signup">signup</a> or{" "}
//                             <a href="/login">login</a> to view your personal
//                             stats.
//                           </Container>
//                         )}
//                       </Card>
//                     </Col>
//                   </Row>
//                   <Row style={{ padding: "20px 0" }}>
//                     <Card>
//                       <Card.Header as="h4">Labeling Leaderboard</Card.Header>
//                       <Container
//                         className="mobile-padding-sm"
//                         style={{ paddingTop: "20px" }}
//                       >
//                         <div className="table-responsive-mobile">
//                           <Table bordered hover size="sm">
//                             <thead>
//                               <tr>
//                                 <th>Ranking</th>
//                                 <th>Name</th>
//                                 <th>No. Components Labeled</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {lboard &&
//                                 lboard.map((user, index) => {
//                                   return (
//                                     <tr key={user.fname}>
//                                       <td>{index + 1}</td>
//                                       {index < 3 ? (
//                                         <td>
//                                           {user.fname} <Trophy />
//                                         </td>
//                                       ) : (
//                                         <td>{user.fname}</td>
//                                       )}
//                                       <td>{user.components.length}</td>
//                                     </tr>
//                                   );
//                                 })}
//                             </tbody>
//                           </Table>
//                         </div>
//                       </Container>
//                     </Card>
//                   </Row>
//                 </Container>
//               </div>
//             </div>
//           );
//         }
//       }}
//     </AuthConsumer>
//   );
// };

// export default ResultsPage;
// // import { React, useState, useEffect } from "react";
// // import axios from "axios";
// // import Row from "react-bootstrap/Row";
// // import Col from "react-bootstrap/Col";
// // import Container from "react-bootstrap/Container";
// // import Table from "react-bootstrap/Table";
// // import Card from "react-bootstrap/Card";
// // import { Trophy } from "react-bootstrap-icons";
// // import { AuthConsumer } from "../helpers/AuthContext";
// // import Sidebar from "../components/Sidebar";
// // import "../styles/responsive.css";
// import "../styles/results.css";

// // const FULLY_LABELED_THRESHOLD = 4;

// // const ResultsPage = () => {
// //   //user list
// //   const [userList, setUserList] = useState(null);

// //   //Leaderboard list
// //   const [lboard, setLboard] = useState(null);

// //   //personal stats
// //   const [pstats, setPstats] = useState(null);

// //   //overall stats
// //   const [ostats, setOstats] = useState(null);
// //   const [total, setTotal] = useState(0);
// //   const [fullyLabeled, setFullyLabeled] = useState(0);

// //   const getUserData = () => {
// //     if (userList && pstats && lboard) {
// //       return;
// //     }

// //     axios.get("/api/users/userlist").then((res) => {
// //       //setting user list
// //       setUserList(res.data);
// //     });
// //   };

// //   const getCompData = () => {
// //     if (total) {
// //       return;
// //     }

// //     axios.get("/api/components/complist").then((res) => {
// //       //Setting overall stats
// //       setOstats(res.data);
// //     });
// //   };

// //   //Await until after user list is set
// //   useEffect(() => {
// //     if (!userList) {
// //       return;
// //     }

// //     const email = localStorage.getItem("Email");

// //     if (email && email !== "guest") {
// //       setPstats(userList.find((user) => email === user.email));
// //     }

// //     //Sort users and get top results
// //     userList.sort((a, b) =>
// //       a.components.length < b.components.length ? 1 : -1
// //     );

// //     const nor = 10;
// //     setLboard(userList.slice(0, nor));
// //   }, [userList]);

// //   //Await until after overall stats have been set
// //   useEffect(() => {
// //     if (!ostats) {
// //       return;
// //     }

// //     let sum = 0;
// //     let fullyLabeledCount = 0;
// //     for (let i = 0; i < ostats.length; i++) {
// //       sum += ostats[i].labels.length;
// //       if (ostats[i].labels.length >= FULLY_LABELED_THRESHOLD) {
// //         fullyLabeledCount += 1;
// //       }
// //     }

// //     setFullyLabeled(fullyLabeledCount);
// //     setTotal(sum);
// //   }, [ostats]);

// //   //Page reload use effect
// //   useEffect(() => {
// //     //Get leaderboard data
// //     getUserData();
// //     getCompData();
// //   }, []);

// //   return (
// //     <AuthConsumer>
// //       {({ Auth }) => {
// //         //If admin
// //         if (Auth === "Admin") {
// //           return (
// //             <div>
// //               <Sidebar />
// //               <div className="content-with-sidebar">
// //                 <Container className="mobile-padding-sm">
// //                   <Row style={{ padding: "20px 0" }}>
// //                     <Col xs={12} lg={6} className="mb-3 mb-lg-0">
// //                       <Card>
// //                         <Card.Header as="h5">Overall IC Stats</Card.Header>
// //                         <Container
// //                           className="mobile-padding-sm"
// //                           style={{ paddingTop: "20px" }}
// //                         >
// //                           <div className="table-responsive-mobile">
// //                             <Table bordered hover size="sm">
// //                               <thead>
// //                                 <tr>
// //                                   <th colSpan="2">Component Stats</th>
// //                                 </tr>
// //                               </thead>
// //                               {ostats && (
// //                                 <tbody>
// //                                   <tr>
// //                                     <td>Unique Components Labeled</td>
// //                                     <td>{ostats.length}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>Total Components Labeled</td>
// //                                     <td>{total}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>{`Fully Labeled Components (${FULLY_LABELED_THRESHOLD} Or More Labels)`}</td>
// //                                     <td>{fullyLabeled}</td>
// //                                   </tr>
// //                                 </tbody>
// //                               )}
// //                             </Table>
// //                           </div>
// //                         </Container>
// //                       </Card>
// //                     </Col>
// //                     <Col xs={12} lg={6}>
// //                       <Card>
// //                         <Card.Header as="h5">Personal Stats</Card.Header>
// //                         {pstats ? (
// //                           <Container
// //                             className="mobile-padding-sm"
// //                             style={{ paddingTop: "20px" }}
// //                           >
// //                             <div className="table-responsive-mobile">
// //                               <Table bordered hover size="sm">
// //                                 <thead>
// //                                   <tr>
// //                                     <th colSpan="2">{pstats.fname}</th>
// //                                   </tr>
// //                                 </thead>
// //                                 <tbody>
// //                                   <tr>
// //                                     <td>Domain</td>
// //                                     <td>{pstats.domain}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>Components Labeled</td>
// //                                     <td>{pstats.components.length}</td>
// //                                   </tr>
// //                                 </tbody>
// //                               </Table>
// //                             </div>
// //                           </Container>
// //                         ) : (
// //                           <Container
// //                             className="mobile-padding-sm"
// //                             style={{
// //                               paddingTop: "20px",
// //                               paddingBottom: "20px",
// //                             }}
// //                           >
// //                             Please <a href="/signup">signup</a> or{" "}
// //                             <a href="/login">login</a> to view your personal
// //                             stats.
// //                           </Container>
// //                         )}
// //                       </Card>
// //                     </Col>
// //                   </Row>
// //                   <Row style={{ padding: "20px 0" }}>
// //                     <Card>
// //                       <Card.Header as="h4">Labeling Leaderboard</Card.Header>
// //                       <Container
// //                         className="mobile-padding-sm"
// //                         style={{ paddingTop: "20px" }}
// //                       >
// //                         <div className="table-responsive-mobile">
// //                           <Table bordered hover size="sm">
// //                             <thead>
// //                               <tr>
// //                                 <th>Ranking</th>
// //                                 <th>Name</th>
// //                                 <th>No. Components Labeled</th>
// //                               </tr>
// //                             </thead>
// //                             <tbody className="leaderboard-table">
// //                               {lboard &&
// //                                 lboard.map((user, index) => (
// //                                   <tr
// //                                     key={user.fname}
// //                                     className={
// //                                       index === 0
// //                                         ? "rank-1"
// //                                         : index === 1
// //                                         ? "rank-2"
// //                                         : index === 2
// //                                         ? "rank-3"
// //                                         : ""
// //                                     }
// //                                   >
// //                                     <td style={{ fontWeight: "600" }}>
// //                                       {index + 1}
// //                                     </td>

// //                                     <td>
// //                                       <div className="trophy-name">
// //                                         {user.fname}
// //                                         {index < 3 && <Trophy />}
// //                                       </div>
// //                                     </td>

// //                                     <td style={{ fontWeight: "600" }}>
// //                                       {user.components.length}
// //                                     </td>
// //                                   </tr>
// //                                 ))}
// //                             </tbody>
// //                           </Table>
// //                         </div>
// //                       </Container>
// //                     </Card>
// //                   </Row>
// //                 </Container>
// //               </div>
// //             </div>
// //           );
// //         }

// //         //If logged in user
// //         else if (Auth === "User") {
// //           return (
// //             <div>
// //               <Sidebar />
// //               <div className="content-with-sidebar">
// //                 <Container className="mobile-padding-sm">
// //                   <Row style={{ padding: "20px 0" }}>
// //                     <Col xs={12} lg={6} className="mb-3 mb-lg-0">
// //                       <Card>
// //                         <Card.Header as="h5">Overall IC Stats</Card.Header>
// //                         <Container
// //                           className="mobile-padding-sm"
// //                           style={{ paddingTop: "20px" }}
// //                         >
// //                           <div className="table-responsive-mobile">
// //                             <Table bordered hover size="sm">
// //                               <thead>
// //                                 <tr>
// //                                   <th colSpan="2">Component Stats</th>
// //                                 </tr>
// //                               </thead>
// //                               {ostats && (
// //                                 <tbody>
// //                                   <tr>
// //                                     <td>Unique Components Labeled</td>
// //                                     <td>{ostats.length}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>Total Components Labeled</td>
// //                                     <td>{total}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>{`Fully Labeled Components (${FULLY_LABELED_THRESHOLD} Or More Labels)`}</td>
// //                                     <td>{fullyLabeled}</td>
// //                                   </tr>
// //                                 </tbody>
// //                               )}
// //                             </Table>
// //                           </div>
// //                         </Container>
// //                       </Card>
// //                     </Col>
// //                     <Col xs={12} lg={6}>
// //                       <Card>
// //                         <Card.Header as="h5">Personal Stats</Card.Header>
// //                         {pstats ? (
// //                           <Container
// //                             className="mobile-padding-sm"
// //                             style={{ paddingTop: "20px" }}
// //                           >
// //                             <div className="table-responsive-mobile">
// //                               <Table bordered hover size="sm">
// //                                 <thead>
// //                                   <tr>
// //                                     <th colSpan="2">{pstats.fname}</th>
// //                                   </tr>
// //                                 </thead>
// //                                 <tbody>
// //                                   <tr>
// //                                     <td>Domain</td>
// //                                     <td>{pstats.domain}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>Components Labeled</td>
// //                                     <td>{pstats.components.length}</td>
// //                                   </tr>
// //                                 </tbody>
// //                               </Table>
// //                             </div>
// //                           </Container>
// //                         ) : (
// //                           <Container
// //                             className="mobile-padding-sm"
// //                             style={{
// //                               paddingTop: "20px",
// //                               paddingBottom: "20px",
// //                             }}
// //                           >
// //                             Please <a href="/signup">signup</a> or{" "}
// //                             <a href="/login">login</a> to view your personal
// //                             stats.
// //                           </Container>
// //                         )}
// //                       </Card>
// //                     </Col>
// //                   </Row>
// //                   <Row style={{ padding: "20px 0" }}>
// //                     <Card>
// //                       <Card.Header as="h4">Labeling Leaderboard</Card.Header>
// //                       <Container
// //                         className="mobile-padding-sm"
// //                         style={{ paddingTop: "20px" }}
// //                       >
// //                         <div className="table-responsive-mobile">
// //                           <Table bordered hover size="sm">
// //                             <thead>
// //                               <tr>
// //                                 <th>Ranking</th>
// //                                 <th>Name</th>
// //                                 <th>No. Components Labeled</th>
// //                               </tr>
// //                             </thead>
// //                             <tbody>
// //                               {lboard &&
// //                                 lboard.map((user, index) => {
// //                                   return (
// //                                     <tr key={user.fname}>
// //                                       <td>{index + 1}</td>
// //                                       {index < 3 ? (
// //                                         <td>
// //                                           {user.fname} <Trophy />
// //                                         </td>
// //                                       ) : (
// //                                         <td>{user.fname}</td>
// //                                       )}
// //                                       <td>{user.components.length}</td>
// //                                     </tr>
// //                                   );
// //                                 })}
// //                             </tbody>
// //                           </Table>
// //                         </div>
// //                       </Container>
// //                     </Card>
// //                   </Row>
// //                 </Container>
// //               </div>
// //             </div>
// //           );
// //         }

// //         //If guest
// //         else {
// //           return (
// //             <div>
// //               <Sidebar />
// //               <div className="content-with-sidebar">
// //                 <Container className="mobile-padding-sm">
// //                   <Row style={{ padding: "20px 0" }}>
// //                     <Col xs={12} lg={6} className="mb-3 mb-lg-0">
// //                       <Card>
// //                         <Card.Header as="h5">Overall IC Stats</Card.Header>
// //                         <Container
// //                           className="mobile-padding-sm"
// //                           style={{ paddingTop: "20px" }}
// //                         >
// //                           <div className="table-responsive-mobile">
// //                             <Table bordered hover size="sm">
// //                               <thead>
// //                                 <tr>
// //                                   <th colSpan="2">Component Stats</th>
// //                                 </tr>
// //                               </thead>
// //                               {ostats && (
// //                                 <tbody>
// //                                   <tr>
// //                                     <td>Unique Components Labeled</td>
// //                                     <td>{ostats.length}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>Total Components Labeled</td>
// //                                     <td>{total}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>{`Fully Labeled Components (${FULLY_LABELED_THRESHOLD} Or More Labels)`}</td>
// //                                     <td>{fullyLabeled}</td>
// //                                   </tr>
// //                                 </tbody>
// //                               )}
// //                             </Table>
// //                           </div>
// //                         </Container>
// //                       </Card>
// //                     </Col>
// //                     <Col xs={12} lg={6}>
// //                       <Card>
// //                         <Card.Header as="h5">Personal Stats</Card.Header>
// //                         {pstats ? (
// //                           <Container
// //                             className="mobile-padding-sm"
// //                             style={{ paddingTop: "20px" }}
// //                           >
// //                             <div className="table-responsive-mobile">
// //                               <Table bordered hover size="sm">
// //                                 <thead>
// //                                   <tr>
// //                                     <th colSpan="2">{pstats.fname}</th>
// //                                   </tr>
// //                                 </thead>
// //                                 <tbody>
// //                                   <tr>
// //                                     <td>Domain</td>
// //                                     <td>{pstats.domain}</td>
// //                                   </tr>
// //                                   <tr>
// //                                     <td>Components Labeled</td>
// //                                     <td>{pstats.components.length}</td>
// //                                   </tr>
// //                                 </tbody>
// //                               </Table>
// //                             </div>
// //                           </Container>
// //                         ) : (
// //                           <Container
// //                             className="mobile-padding-sm"
// //                             style={{
// //                               paddingTop: "20px",
// //                               paddingBottom: "20px",
// //                             }}
// //                           >
// //                             Please <a href="/signup">signup</a> or{" "}
// //                             <a href="/login">login</a> to view your personal
// //                             stats.
// //                           </Container>
// //                         )}
// //                       </Card>
// //                     </Col>
// //                   </Row>
// //                   <Row style={{ padding: "20px 0" }}>
// //                     <Card>
// //                       <Card.Header as="h4">Labeling Leaderboard</Card.Header>
// //                       <Container
// //                         className="mobile-padding-sm"
// //                         style={{ paddingTop: "20px" }}
// //                       >
// //                         <div className="table-responsive-mobile">
// //                           <Table bordered hover size="sm">
// //                             <thead>
// //                               <tr>
// //                                 <th>Ranking</th>
// //                                 <th>Name</th>
// //                                 <th>No. Components Labeled</th>
// //                               </tr>
// //                             </thead>
// //                             <tbody>
// //                               {lboard &&
// //                                 lboard.map((user, index) => {
// //                                   return (
// //                                     <tr key={user.fname}>
// //                                       <td>{index + 1}</td>
// //                                       {index < 3 ? (
// //                                         <td>
// //                                           {user.fname} <Trophy />
// //                                         </td>
// //                                       ) : (
// //                                         <td>{user.fname}</td>
// //                                       )}
// //                                       <td>{user.components.length}</td>
// //                                     </tr>
// //                                   );
// //                                 })}
// //                             </tbody>
// //                           </Table>
// //                         </div>
// //                       </Container>
// //                     </Card>
// //                   </Row>
// //                 </Container>
// //               </div>
// //             </div>
// //           );
// //         }
// //       }}
// //     </AuthConsumer>
// //   );
// // };

// // export default ResultsPage;
// import { React, useState, useEffect } from "react";
// import axios from "axios";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import Container from "react-bootstrap/Container";
// import Table from "react-bootstrap/Table";
// import Card from "react-bootstrap/Card";
// import { Trophy } from "react-bootstrap-icons";
// import { AuthConsumer } from "../helpers/AuthContext";
// import Sidebar from "../components/Sidebar";
// import "../styles/responsive.css";
// import "../styles/results.css";

// const FULLY_LABELED_THRESHOLD = 4;

// const ResultsPage = () => {
//   const [userList, setUserList] = useState(null);
//   const [lboard, setLboard] = useState(null);
//   const [pstats, setPstats] = useState(null);
//   const [ostats, setOstats] = useState(null);
//   const [total, setTotal] = useState(0);
//   const [fullyLabeled, setFullyLabeled] = useState(0);

//   const getUserData = () => {
//     if (userList && pstats && lboard) return;

//     axios.get("/api/users/userlist").then((res) => {
//       setUserList(res.data);
//     });
//   };

//   const getCompData = () => {
//     if (total) return;

//     axios.get("/api/components/complist").then((res) => {
//       setOstats(res.data);
//     });
//   };

//   // Sort leaderboard + set personal stats
//   useEffect(() => {
//     if (!userList) return;

//     const email = localStorage.getItem("Email");

//     if (email && email !== "guest") {
//       setPstats(userList.find((u) => u.email === email));
//     }

//     userList.sort((a, b) => b.components.length - a.components.length);
//     setLboard(userList.slice(0, 10));
//   }, [userList]);

//   // overall component stats
//   useEffect(() => {
//     if (!ostats) return;

//     let sum = 0,
//       full = 0;

//     ostats.forEach((c) => {
//       sum += c.labels.length;
//       if (c.labels.length >= FULLY_LABELED_THRESHOLD) full += 1;
//     });

//     setTotal(sum);
//     setFullyLabeled(full);
//   }, [ostats]);

//   useEffect(() => {
//     getUserData();
//     getCompData();
//   }, []);

//   // -----------------------
//   //  Shared UI Components
//   // -----------------------

//   const StatsCard = () => (
//     <Card className="stats-card">
//       <Card.Header as="h5">Overall IC Stats</Card.Header>
//       <Container style={{ paddingTop: "20px" }}>
//         <div className="table-responsive-mobile">
//           <Table bordered hover size="sm">
//             <thead>
//               <tr>
//                 <th colSpan="2">Component Stats</th>
//               </tr>
//             </thead>
//             {ostats && (
//               <tbody>
//                 <tr>
//                   <td>Unique Components Labeled</td>
//                   <td>{ostats.length}</td>
//                 </tr>
//                 <tr>
//                   <td>Total Components Labeled</td>
//                   <td>{total}</td>
//                 </tr>
//                 <tr>
//                   <td>{`Fully Labeled Components (${FULLY_LABELED_THRESHOLD}+ labels)`}</td>
//                   <td>{fullyLabeled}</td>
//                 </tr>
//               </tbody>
//             )}
//           </Table>
//         </div>
//       </Container>
//     </Card>
//   );

//   const PersonalCard = () => (
//     <Card className="stats-card">
//       <Card.Header as="h5">Personal Stats</Card.Header>
//       {pstats ? (
//         <Container style={{ paddingTop: "20px" }}>
//           <div className="table-responsive-mobile">
//             <Table bordered hover size="sm">
//               <thead>
//                 <tr>
//                   <th colSpan="2">{pstats.fname}</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Domain</td>
//                   <td>{pstats.domain}</td>
//                 </tr>
//                 <tr>
//                   <td>Components Labeled</td>
//                   <td>{pstats.components.length}</td>
//                 </tr>
//               </tbody>
//             </Table>
//           </div>
//         </Container>
//       ) : (
//         <Container style={{ paddingTop: "20px", paddingBottom: "20px" }}>
//           Please <a href="/signup">signup</a> or <a href="/login">login</a> to
//           view your personal stats.
//         </Container>
//       )}
//     </Card>
//   );

//   const Leaderboard = () => (
//     <Card className="leaderboard-card">
//       <Card.Header as="h4">Labeling Leaderboard</Card.Header>
//       <Container style={{ paddingTop: "20px" }}>
//         <div className="table-responsive-mobile">
//           <Table bordered hover size="sm" className="leaderboard-table">
//             <thead>
//               <tr>
//                 <th>Rank</th>
//                 <th>Name</th>
//                 <th>No. Labeled</th>
//               </tr>
//             </thead>
//             <div>
//               {lboard &&
//                 lboard.map((user, index) => {
//                   const initials = user.fname.charAt(0).toUpperCase();
//                   const count = user.components.length;

//                   // Podium for top 3
//                   if (index < 3) {
//                     return (
//                       <div
//                         key={user.fname}
//                         className={`podium-row ${
//                           index === 0
//                             ? "rank-1-podium"
//                             : index === 1
//                             ? "rank-2-podium"
//                             : "rank-3-podium"
//                         }`}
//                       >
//                         <div className="podium-rank">
//                           {index === 0 ? "🥇" : index === 1 ? "🥈" : "🥉"}
//                         </div>

//                         <div className="lb-flex">
//                           <div className="lb-user">
//                             <div className="avatar">{initials}</div>
//                             {user.fname}
//                           </div>

//                           <div style={{ fontWeight: 800, fontSize: "20px" }}>
//                             {count}
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   }

//                   // Normal rows
//                   return (
//                     <div key={user.fname} className="lb-row">
//                       <div className="lb-flex">
//                         <div className="lb-user">
//                           <div
//                             className="avatar"
//                             style={{ background: "#6366f1" }}
//                           >
//                             {initials}
//                           </div>
//                           #{index + 1} — {user.fname}
//                         </div>

//                         <div style={{ fontWeight: 700 }}>{count}</div>
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </Table>
//         </div>
//       </Container>
//     </Card>
//   );

//   return (
//     <AuthConsumer>
//       {() => (
//         // inside return (...):
//         <div className="results-page">
//           <Sidebar />
//           <div className="content-with-sidebar">
//             <Container>
//               {/* Stats Row */}
//               <Row style={{ padding: "20px 0" }}>
//                 <Col xs={12} lg={6} className="mb-3">
//                   <Card className="modern-card">
//                     <div className="card-header-modern">Overall IC Stats</div>
//                     <Container style={{ padding: "20px" }}>
//                       <Table bordered={false} className="modern-table">
//                         <tbody>
//                           <tr>
//                             <td>Unique Components Labeled</td>
//                             <td>{ostats?.length}</td>
//                           </tr>
//                           <tr>
//                             <td>Total Components Labeled</td>
//                             <td>{total}</td>
//                           </tr>
//                           <tr>
//                             <td>{`Fully Labeled (≥ ${FULLY_LABELED_THRESHOLD})`}</td>
//                             <td>{fullyLabeled}</td>
//                           </tr>
//                         </tbody>
//                       </Table>
//                     </Container>
//                   </Card>
//                 </Col>

//                 <Col xs={12} lg={6}>
//                   <Card className="modern-card">
//                     <div className="card-header-modern">Personal Stats</div>
//                     <Container style={{ padding: "20px" }}>
//                       {pstats ? (
//                         <Table bordered={false} className="modern-table">
//                           <tbody>
//                             <tr>
//                               <td>Name</td>
//                               <td>{pstats.fname}</td>
//                             </tr>
//                             <tr>
//                               <td>Domain</td>
//                               <td>{pstats.domain}</td>
//                             </tr>
//                             <tr>
//                               <td>Components Labeled</td>
//                               <td>{pstats.components.length}</td>
//                             </tr>
//                           </tbody>
//                         </Table>
//                       ) : (
//                         <>Please login to view stats</>
//                       )}
//                     </Container>
//                   </Card>
//                 </Col>
//               </Row>

//               {/* Leaderboard */}
//               <Row style={{ padding: "20px 0" }}>
//                 <Col xs={12}>
//                   <Card className="modern-card">
//                     <div className="leaderboard-header">🏆 Leaderboard</div>

//                     <Container style={{ padding: "20px" }}>
//                       <Table bordered={false} className="modern-table">
//                         <thead>
//                           <tr>
//                             <th>Rank</th>
//                             <th>User</th>
//                             <th>Labeled</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {lboard &&
//                             lboard.map((user, index) => {
//                               const initials = user.fname
//                                 .charAt(0)
//                                 .toUpperCase();

//                               return (
//                                 <tr
//                                   key={user.fname}
//                                   className={
//                                     index === 0
//                                       ? "rank-1"
//                                       : index === 1
//                                       ? "rank-2"
//                                       : index === 2
//                                       ? "rank-3"
//                                       : ""
//                                   }
//                                 >
//                                   <td style={{ fontWeight: 700 }}>
//                                     #{index + 1}
//                                   </td>

//                                   <td>
//                                     <div className="user-cell">
//                                       <div className="avatar">{initials}</div>
//                                       {user.fname}
//                                       {index < 3 && <Trophy />}
//                                     </div>
//                                   </td>

//                                   <td style={{ fontWeight: 700 }}>
//                                     {user.components.length}
//                                   </td>
//                                 </tr>
//                               );
//                             })}
//                         </tbody>
//                       </Table>
//                     </Container>
//                   </Card>
//                 </Col>
//               </Row>
//             </Container>
//           </div>
//         </div>
//       )}
//     </AuthConsumer>
//   );
// };

// export default ResultsPage;
import { React, useState, useEffect } from "react";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { AuthConsumer } from "../helpers/AuthContext";
import Sidebar from "../components/Sidebar";
import "../styles/responsive.css";
import "../styles/results.css";

const ResultsPage = () => {
  // Competition leaderboards (fresh-start): { campaignStart, topLabelers,
  // topLabs, mostAccurate }. Fetched from /api/users/leaderboard.
  const [boards, setBoards] = useState(null);
  const [activeTab, setActiveTab] = useState("labelers");

  // Competition boards (Top Labelers / Top Labs / Most Accurate).
  const getBoards = () => {
    axios
      .get("/api/users/leaderboard")
      .then((res) => setBoards(res.data))
      .catch(() => {
        // Non-fatal (e.g. logged out) — the board just shows "loading/none".
      });
  };

  // On Load
  useEffect(() => {
    getBoards();
  }, []);

  // -----------------------
  // Leaderboard (PODIUM + MODERN ROWS)
  // -----------------------
  // Competition boards, shown as three tabs. All are "fresh start" (only
  // labels since campaignStart count). Reuses the existing podium row styling.
  const LB_TABS = [
    { key: "labelers", icon: "🏅", label: "Top Labelers" },
    { key: "labs", icon: "🏆", label: "Top Labs" },
    { key: "accurate", icon: "🎯", label: "Most Accurate" },
  ];

  const MEDALS = ["🥇", "🥈", "🥉"];

  const Leaderboard = () => {
    const isLab = activeTab === "labs";
    const rows = boards
      ? isLab
        ? boards.topLabs || []
        : activeTab === "accurate"
        ? boards.mostAccurate || []
        : boards.topLabelers || []
      : [];

    const userHeader = isLab ? "Lab" : "Labeler";
    const valueHeader = activeTab === "accurate" ? "Correct" : "Labels";

    // The requester's own standing on the active board (from boards.me).
    const me = boards && boards.me;
    const meTab = me
      ? isLab
        ? me.labs
        : activeTab === "accurate"
        ? me.accurate
        : me.labelers
      : null;
    // Am I already shown in the top 10? Matched by identity (row.isMe from the
    // backend), never by rank number — so "(You)" can't land on someone else.
    const meInList = rows.some((r) => r.isMe);
    const meName = isLab ? meTab && meTab.lab : me && me.name;
    const meValue = meTab
      ? isLab
        ? meTab.total
        : activeTab === "accurate"
        ? meTab.correct
        : meTab.count
      : null;

    return (
      <div className="lbx-card">
        <div className="lbx-head">
          <div className="lbx-title">
            <span className="lbx-trophy">🏆</span> Leaderboard
          </div>
        </div>

        <div className="lbx-tabs" role="tablist">
          {LB_TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={activeTab === t.key}
              className={`lbx-tab ${activeTab === t.key ? "is-active" : ""}`}
              onClick={() => setActiveTab(t.key)}
            >
              <span className="lbx-tab-ic">{t.icon}</span>
              {t.label}
            </button>
          ))}
        </div>

        <div className="lbx-colhead">
          <span>Rank</span>
          <span>{userHeader}</span>
          <span className="lbx-col-val">{valueHeader}</span>
        </div>

        <div className="lbx-list">
          {!boards ? (
            <div className="lbx-empty">Loading…</div>
          ) : rows.length === 0 ? (
            <div className="lbx-empty">
              {isLab
                ? "No labs on the board yet — set your lab under “Edit profile” to join the race."
                : "No labels counted yet since the competition started."}
            </div>
          ) : (
            rows.map((row, index) => {
              const displayName = isLab ? row.lab : row.name;
              const value = isLab
                ? row.total
                : activeTab === "accurate"
                ? row.correct
                : row.count;
              const initials = (displayName || "?").charAt(0).toUpperCase();
              const sub = isLab
                ? `${row.members} member${row.members === 1 ? "" : "s"}`
                : row.lab || "";
              const top = index < 3;
              const isMe = !!row.isMe;

              return (
                <div
                  key={displayName + "-" + index}
                  className={`lbx-row ${top ? "lbx-top lbx-top-" + (index + 1) : ""} ${isMe ? "lbx-me" : ""}`}
                >
                  <div className="lbx-rank">
                    {top ? (
                      MEDALS[index]
                    ) : (
                      <span className="lbx-rank-n">{index + 1}</span>
                    )}
                  </div>

                  <div className="lbx-user">
                    <span className={`lbx-av lbx-av-${top ? index + 1 : "d"}`}>
                      {initials}
                    </span>
                    <span className="lbx-meta">
                      <span className="lbx-name">
                        {displayName}
                        {isMe && <span className="lbx-you"> (You)</span>}
                      </span>
                      {sub && <span className="lbx-lab">{sub}</span>}
                    </span>
                  </div>

                  <div className="lbx-val">{value}</div>
                </div>
              );
            })
          )}

          {/* Your own standing when you're not already shown in the top 10 */}
          {boards && rows.length > 0 && meTab && !meInList && (
            <div className="lbx-row lbx-me lbx-mebar">
              <div className="lbx-rank">
                <span className="lbx-rank-n">{meTab.rank}</span>
              </div>
              <div className="lbx-user">
                <span className="lbx-av lbx-av-d">
                  {(meName || "?").charAt(0).toUpperCase()}
                </span>
                <span className="lbx-meta">
                  <span className="lbx-name">
                    {meName}
                    <span className="lbx-you"> (You)</span>
                  </span>
                  {isLab && meTab.members != null && (
                    <span className="lbx-lab">
                      {meTab.members} member{meTab.members === 1 ? "" : "s"}
                    </span>
                  )}
                </span>
              </div>
              <div className="lbx-val">{meValue}</div>
            </div>
          )}

          {/* Logged in but not on this board yet */}
          {boards && rows.length > 0 && me && !meTab && (
            <div className="lbx-notme">
              {isLab
                ? me.lab
                  ? "Your lab hasn’t scored in this competition yet."
                  : "Set your lab (Dashboard) to join the lab race."
                : "You haven’t scored in this competition yet — start labeling to get on the board!"}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <AuthConsumer>
      {() => (
        <div className="results-page">
          <Sidebar />
          <div className="content-with-sidebar">
            <Container>
              {/* Leaderboard */}
              <Row style={{ padding: "20px 0" }}>
                <Col xs={12}>
                  <Leaderboard />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}
    </AuthConsumer>
  );
};

export default ResultsPage;
